import { Avatar } from "@mui/material";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import isEmpty from "../../../utils/isempty.utils";
import MuiUserUtils from "../../../utils/mui.user.utils";

const CardUserMinimal = () => {
  const user = useSelector((state: any) => state.userReducer);
  const [name, setName] = useState<string>("ADMINISTRATEUR");

 
  useEffect(() => {
    setName("ADMINISTRATEUR");
  }, [user]);

  return (
    <div className="component-card-user-minimal">
      <Avatar
        {...MuiUserUtils.stringAvatar(name)}
        sx={{ backgroundColor: "rgba(34, 10, 110,1)", borderRadius: "50%" }}
      />
      <div className="user-information">
        <div className="title">ADMINISTRATEUR</div>
        <div className="subtitle">admin@leblr.com</div>
      </div>
    </div>
  );
};

export default CardUserMinimal;
